import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header1 from '../components/Header1';
import Footer from '../components/Footer';

const VerifyCode = () => {
    const [typedCode, setTypedCode] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;

    const handleVerify = async (e) => {
        e.preventDefault();
        setError(''); // Reset any existing error messages before sending

        try {
            const verificationToken = sessionStorage.getItem('temp_verify_token');

            // 💡 UPDATED: Points to the new secure MFA device-tracking route
            // 💡 CRITICAL: withCredentials enables cookie drops across origins (CORS)
            const res = await axios.post(
                `${API_URL}/api/auth/verify-login-mfa`, 
                {
                    typedCode,
                    verificationToken
                },
                {
                    withCredentials: true 
                }
            );

            if (res.status === 200) {
                // Wipe the temporary token out of memory
                sessionStorage.removeItem('temp_verify_token');
                
                // Store the primary app access token
                localStorage.setItem('token', res.data.token);
                
                // 🎉 Route straight into your active application dashboard path
                navigate('/cards');
            }
        } catch (error) {
            console.error('MFA payload verification failure:', error);
            // Grab specific contextual message loops from the backend engine
            if (error.response && error.response.data && error.response.data.message) {
                setError(error.response.data.message);
            } else {
                setError('Invalid code or session window has expired.');
            }
        }
    };

    return (
        <>
            <Header1 />
            <div className="signup-container">
                <form onSubmit={handleVerify}>
                    <h2>Enter Verification Code</h2>
                    {error && <div className="error-message">{error}</div>}
                    <input 
                        type="text" 
                        placeholder="6-Digit Code" 
                        value={typedCode} 
                        onChange={(e) => setTypedCode(e.target.value)} 
                        maxLength="6"
                        style={{ textAlign: 'center', letterSpacing: '4px', fontSize: '18px' }}
                        required 
                    />
                    <button type="submit">Confirm Activation</button>
                </form>
            </div>
            <Footer />
        </>
    );
};

export default VerifyCode;